import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { signup } from 'services/coversationService';
import brandLogo from '../../assets/images/logo.svg'
import { eyeIcon, CloseEyeIcon } from '../../assets/icons';
import { ToastContent, toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { handleLoader } from 'redux/counterSlice';

const Signup = () => {
    const [formValue, setFormValue] = useState<{
        firstName: string,
        lastName: string,
        email: string,
        password: string,
        confirmPassword: string,
        // check: false
    }>({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
        // check: false
    });
    const [errors, setErrors] = useState<any>({});
    const [showPassword, setShowPassword] = useState(false);
    const dispatch = useDispatch();
    const [showCnfPassword, setShowCnfPassword] = useState(false);
    const navigate = useNavigate();

    // useEffect(() => {

    //     if (isLogged) {
    //         navigate('/');
    //     } else {
    //         navigate('/signup');
    //     }
    // }, [navigate]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // if (e.target.name !== "check") {
        setFormValue({ ...formValue, [e.target.name]: e.target.value });
        // } else {
        //     setFormValue({ ...formValue, [e.target.name]: e.target.checked });
        // }
    };

    // const passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    const passRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
    const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
    const containsUppercase = /[A-Z]/;



    const handleValidation = (formValue: { [x: string]: any }) => {
        const errors: { [x: string]: any } = {};
        if (!formValue.firstName) {
            errors.firstName = 'First name is required';
        }
        if (!formValue.lastName) {
            errors.lastName = 'Last name is required';
        }
        if (!formValue.email) {
            errors.email = 'Email is required';
        }
        if (formValue.email && !emailRegex.test(formValue.email)) {
            errors.email = 'Please enter valid Email';
        }
        if (formValue.email && containsUppercase.test(formValue.email)) {
            errors.email = 'Email must only contain lowercase letters';
        }
        if (!formValue.password) {
            errors.password = 'Password is required';
        }
        if (formValue.password && !passRegex.test(formValue.password)) {
            errors.password = 'Password must be of minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character';
        }
        if (!formValue.confirmPassword) {
            errors.confirmPassword = 'Confirm Password is required';
        }
        if (formValue.confirmPassword !== formValue.password && formValue.confirmPassword.length !== 0) {
            errors.confirmPassword = 'Confirm Password does not match with the new password';
        }
        return errors;
    }

    const handleRegeister = async (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        // Perform validation
        const validationErrors = handleValidation(formValue);

        if (Object.keys(validationErrors).length === 0) {
            dispatch(handleLoader(true));
            try {
                const { result, error } = await signup(formValue)
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
                dispatch(handleLoader(false));
                setTimeout(() => {
                    if (localStorage.getItem('clientName') !== 'Amspec_clone') {
                        navigate("/login")
                    } else {
                        navigate("/login?env=AmSpec")
                    }
                }, 2500);
            } catch (error) {
                dispatch(handleLoader(false));
                toast.error(error as ToastContent<unknown>, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            }
        } else {
            dispatch(handleLoader(false));
            // Form is invalid; display validation errors
            setErrors(validationErrors);
        }
    }
    const loginTransfer = () => {
        if (localStorage.getItem('clientName') === 'Amspec_clone') {
            navigate("/login?env=AmSpec")
        } else {
            navigate("/login")
        }
    }


    const logos = JSON.parse(localStorage.getItem('logos') as any);
    const logo: any = logos !== null || logos !== "" ? `data:image/png;base64,${logos?.logo_home_page}` : brandLogo;

    return (
        <div className="login-container login-container-signup">
            <div className='login-main'>
                {/* <div className='login-left'>
                    <div className='login-left_top'>
                        <img src={register} className='left-image' alt="signup" />
                    </div>
                    <div className='login-left_bottom'></div>
                </div> */}
                <div className='login-right'>
                    <img src={logo} className='logo' alt="logo" />
                    <h3 className='login-header'>Sign up your account</h3>
                    <form className='form'>
                        <div className='form-field2'>
                            <div>
                                <label className='form-label'>First Name</label>
                                <span className="text-red-600">*</span>
                            </div>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Enter your First Name"
                                name='firstName'
                                value={formValue.firstName}
                                onChange={
                                    (e) => {
                                        delete errors.firstName;
                                        handleChange(e);
                                    }
                                }
                                required
                                autoComplete="new-password"
                            />
                            {errors.firstName && <span className="mt-2 text-danger">{errors.firstName}</span>}
                        </div>
                        <div className='form-field2'>
                            <div>
                                <label className='form-label'>Last Name</label>
                                <span className="text-red-600">*</span>
                            </div>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Enter your Last Name"
                                name='lastName'
                                value={formValue.lastName}
                                onChange={(e) => {
                                    delete errors.lastName;
                                    handleChange(e);
                                }}
                                required
                                autoComplete="new-password"
                            />
                            {errors.lastName && <span className="mt-2 text-danger">{errors.lastName}</span>}
                        </div>
                        <div className='form-field2'>
                            <div>
                                <label className='form-label'>Email</label>
                                <span className="text-red-600">*</span>
                            </div>
                            <input
                                className="form-control"
                                type="email"
                                name='email'
                                placeholder="Enter your Email"
                                value={formValue.email}
                                onChange={(e) => {
                                    delete errors.email;
                                    handleChange(e);
                                }}
                                required
                                autoComplete="new-password"
                            />
                            {errors.email && <span className="mt-2 text-danger">{errors.email}</span>}
                        </div>
                        <div className='form-field2'>
                            <div>
                                <label className='form-label'>Password</label>
                                <span className="text-red-600">*</span>
                            </div>
                            <div className='password position-relative'>
                                <input
                                    className="form-control"
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    placeholder="Enter your Password"
                                    required
                                    value={formValue.password}
                                    onChange={(e) => {
                                        delete errors.password;
                                        handleChange(e);
                                    }}
                                    autoComplete="new-password"
                                />
                                <span className={`password-toggle position-absolute top-50 end-0 w-auto translate-middle`} onClick={() => setShowPassword(!showPassword)}>
                                    {!showPassword ? <img id='eyeicon' src={CloseEyeIcon} alt="eye-icon" /> :
                                        <img id='close-eye-icon' src={eyeIcon} alt="close-eye-icon" />
                                    }
                                </span>
                            </div>
                            {errors.password && <span className="mt-2 text-danger">{errors.password}</span>}
                        </div>
                        <div className='form-field2'>
                            <div>
                                <label className='form-label'>Confirm Password</label>
                                <span className="text-red-600">*</span>
                            </div>
                            <div className='password position-relative'>
                                <input
                                    className="form-control"
                                    type={showCnfPassword ? "text" : "password"}
                                    placeholder="Confirm your Password"
                                    name='confirmPassword'
                                    required
                                    value={formValue.confirmPassword}
                                    onChange={(e) => {
                                        delete errors.confirmPassword;
                                        handleChange(e);
                                    }}
                                    autoComplete="new-password"
                                />
                                <span className={`password-toggle position-absolute top-50 end-0 w-auto translate-middle`} onClick={() => setShowCnfPassword(!showCnfPassword)}>
                                    {!showCnfPassword ? <img id='eyeicon' src={CloseEyeIcon} alt="eye-icon" /> :
                                        <img id='close-eye-icon' src={eyeIcon} alt="close-eye-icon" />
                                    }
                                </span>
                            </div>
                        </div>
                        {errors.confirmPassword && <span className="mt-2 text-danger">{errors.confirmPassword}</span>}
                        {/* <div className="form-check">
                            <input className="form-check-input" name='check' type="checkbox" id="flexCheckDefault"
                                checked={formValue.check}
                                onChange={(e) => {
                                    delete errors.check;
                                    handleChange(e);
                                }}
                            />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                I Accept the <a >Terms</a>
                            </label>
                        </div>
                        {errors.check && <span className="mt-2 text-danger">{errors.check}</span>} */}
                        <button className='btn btn-primary mt-4 w-100' onClick={handleRegeister}>Sign Up</button>
                        <p className='register-text text-center'>Have an account? <strong className="str-point" onClick={loginTransfer}>Sign In</strong></p>
                    </form>
                </div>

            </div>
        </div>
    )
}

export default Signup